import * as React from 'react'
import { useCallback } from 'react'

import Paper from '@mui/material/Paper'
import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'

import { TidalBillToSelectCardContents } from './BillToRadioCardContents/TidalBillToSelectCardContents'

import { BillTo } from '@user/store/entityLocations'

type Props = {
  checked?: boolean
  location: BillTo
  onClick: (locationId: string) => void
}

export function TidalBillToRadioCard(props: Props) {
  const { checked = false, location, onClick } = props

  const handleClick = useCallback(() => {
    onClick(location.id)
  }, [location.id, onClick])

  return (
    <Paper
      elevation={2}
      sx={{
        mb: 1,
        pt: 2.125,
        px: 3,
        pb: 1,
      }}
    >
      <FormControlLabel
        checked={checked}
        value={true}
        control={<Radio size="medium" />}
        label="Select Customer"
        labelPlacement="end"
        onClick={handleClick}
      />
      <TidalBillToSelectCardContents location={location} />
    </Paper>
  )
}
